<article class="calendar">
  @if (timeRangeView()) {
    <ul class="calendar-date-list custom-scrollbar">
      @for (
        timeRange of TIME_RANGE_NAME | keyvalue: keepCompareOrder;
        track $index
      ) {
        @if (timeRange.value !== TIME_RANGE_NAME.CUSTOM) {
          <li
            class="calendar-date-list__item"
            [class.calendar-date-list__item--selected]="
              selectedTimeRangeName() === timeRange.value
            "
            [attr.time-range-name]="timeRange.value"
            [attr.time-range-value]="
              timeRange.value | useFunction: generateTimeRange
            "
            [attr.aria-label]="timeRange.value"
          >
            <button type="button" (click)="setTimeRangeName(timeRange.value)">
              {{ timeRange.value | timeRange }}
            </button>
          </li>
        }
      }
      <li
        class="calendar-date-list__item"
        [class.calendar-date-list__item--selected]="
          selectedTimeRangeName() === TIME_RANGE_NAME.CUSTOM
        "
        [attr.time-range-name]="TIME_RANGE_NAME.CUSTOM"
        [ariaLabel]="TIME_RANGE_NAME.CUSTOM | timeRange"
      >
        <button (click)="picker.open()">
          {{
            customTimeRange()
              ? (customTimeRange()?.start
                  | date: 'dd/MM/yyyy' : undefined : 'fr') +
                ' - ' +
                (customTimeRange()?.end | date: 'dd/MM/yyyy' : undefined : 'fr')
              : (TIME_RANGE_NAME.CUSTOM | timeRange)
          }}
        </button>
      </li>
    </ul>

    <mat-date-range-input [rangePicker]="picker" #range>
      <input
        matStartDate
        [value]="
          customTimeRange()?.start
            ? _dateService.instance(customTimeRange()!.start).toDate()
            : null
        "
      />
      <input
        matEndDate
        [value]="
          customTimeRange()?.end
            ? _dateService.instance(customTimeRange()!.end).toDate()
            : null
        "
        (dateChange)="setCustomTimeRange(range.value)"
      />
    </mat-date-range-input>
    <mat-date-range-picker
      #picker
      xPosition="end"
      panelClass="custom-range-calendar"
      [calendarHeaderComponent]="calendarHeader"
    ></mat-date-range-picker>
  } @else {
    <mat-calendar
      [headerComponent]="calendarHeader"
      (selectedChange)="handleSelectedChange($event)"
      [selected]="selectedDate()"
      class="custom-range-calendar"
    ></mat-calendar>
  }
</article>
